export const normalizeSearch = value => String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase().trim();
export function groupCompanies(companies, connections) {
 const byCompany = new Map();
 connections.forEach(connection => {
  const id = String(connection.companyId);
  if (!byCompany.has(id)) byCompany.set(id, []);
  byCompany.get(id).push(connection);
 });
 return companies.map(company => {
  const rows = byCompany.get(String(company.id)) || [];
  const connected = rows.filter(row => row.status === "CONNECTED").length;
  return { ...company, connections: rows, connected, attention: rows.length - connected, total: rows.length };
 }).sort((a, b) => String(a.name || "").localeCompare(String(b.name || ""), "pt-BR"));
}
export function matchesCompany(company, search, status) {
 const query = normalizeSearch(search);
 const match = !query || normalizeSearch(company.name).includes(query) || String(company.id) === query || company.connections.some(row =>
  normalizeSearch(row.name).includes(query) || (/\d/.test(query) && /^[\d+()\s.-]+$/.test(query) && String(row.number || "").replace(/\D/g, "").includes(query.replace(/\D/g, "")))
 );
 return match && (!status || (status === "attention" && company.attention > 0) || (status === "connected" && company.connected > 0) || (status === "empty" && company.total === 0));
}
export const statusLabels = { CONNECTED: "Conectada", DISCONNECTED: "Desconectada", PENDING: "Aguardando reconexão", OPENING: "Conectando…", qrcode: "Aguardando QR code", PAIRING: "Sincronizando", TIMEOUT: "Conexão interrompida" };
